import { type DatiSessioneUtenteUtenteLoggato } from '@framework/api-client/api/users/schemas/datiSessioneUtenteUtenteLoggato.ts';

/**
 * Funzione per riconoscere se l'utente corrente è il mittente
 * da verificarne se copre tutti i casi d'uso
 */
export const getIsCommunicationCurrentUser = (
  id?: string | null | undefined,
  currentUser?: DatiSessioneUtenteUtenteLoggato | undefined,
): boolean => {
  if (!currentUser || !id) {
    return false;
  }
  const ids = currentUser?.utenteUfficis?.map(u => u.idUfficio) ?? [];
  return [...ids, currentUser?.idUtente].includes(id);
};
